/** Shared mobile bottom nav layout tokens */
export const MOBILE_NAV_BAR_HEIGHT = 64

export const mobileNavSafeBottom = 'env(safe-area-inset-bottom, 0px)'

export const mobileNavOffset = `calc(${MOBILE_NAV_BAR_HEIGHT}px + ${mobileNavSafeBottom})`

/** Generic pages — content clears the bottom tab bar only */
export const mobileMainPaddingBottom = mobileNavOffset

/** Product detail — sticky add-to-cart bar sits above the bottom tab bar */
export const MOBILE_STICKY_CTA_HEIGHT = 76

export const mobilePdpPaddingBottom = `calc(${MOBILE_NAV_BAR_HEIGHT}px + ${MOBILE_STICKY_CTA_HEIGHT}px + ${mobileNavSafeBottom})`

export const mobileStickyCtaBottom = mobileNavOffset
